import { env } from "@/env";
import { NovuProvider as NovuProviderSDK } from "@novu/react";
import { useRouteContext } from "@tanstack/react-router";

export function NovuProvider({ children }: { children: React.ReactNode }) {
	const { club, session } = useRouteContext({ from: "__root__" });

	if (!session?.user) {
		return <>{children}</>;
	}

	const novuIdentifier = `${club.rawID}:${session?.user?.rawID}`;

	return (
		<NovuProviderSDK
			applicationIdentifier={env.VITE_NOVU_APP_ID}
			subscriber={novuIdentifier}
		>
			{children}
		</NovuProviderSDK>
	);
}
